<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-2 p-pb-6">
      <div class="p-grid p-ai-center vertical-container">
          <!-- <div class="p-col-fixed" style="width:55px;">
              <a @click="$functions.historyBack()" style="cursor: pointer">
                <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')"/>
              </a>
          </div> -->
          <div class="p-col">
              <h3 v-if="reportId!=null && serialNumber!=null">{{ serialNumber }} - (Report id: {{ reportId }})</h3>
              <h3 v-else>{{ $t('report.edit.title') }} {{ $route.query.serialNumber ? '- '+$route.query.serialNumber : '' }}</h3>
          </div>
          <div v-if="gamma!=null && $config.currentEnv=='dev'" class="p-col-fixed p-text-right " style="width: 200px">
              <span style="font-size: .8rem; color: #A70008;">{{ extras.imperial ? $t('preferences.ms.imperial') : $t('preferences.ms.metric') }}</span>
          </div>
      </div>

      <div class="irinox-form report-installazione">


        <div v-show="step===0" class="p-formgroup-inline p-ai-center">
          <div class="p-field">
            <Dropdown id="gamme" v-model="gamma" :options="gamme" optionLabel="name" optionValue="code"
              :placeholder="$t('report.edit.filter_gamma_ph')" style="width: 200px" :disabled="reportId!=null || $route.query.gamma!=null"/>
          </div>
        </div>

        <div v-if="report && gamma && (role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY')">
          <div v-for="(value, key, index) in structures[gamma]" :key="'section_'+key">
            <Section v-if="step===index" :name="key" :structure="value" :data="report[key]" :reportId="reportId" :domains="domains" :extras="extras" @update:data="dataChanged" :overwriteData="overwriteData[key] ?? {}" /> 
          </div>
          
          <Overview v-if="step>Object.keys(structures[gamma]).length-1" :reportId="reportId" :report="report" :extras="extras"
            :structure="structures[gamma]" :domains="domains"
            @update:data="dataChanged" 
            @update:images="imagesChanged" 
            @update:signature="signatureChanged" 
            :status="status"
          />
        </div>
        <div v-if="report && gamma && role.includes('INTERNAL')">
          <Overview v-if="step>Object.keys(structures[gamma]).length-1" :reportId="reportId" :report="report" :extras="extras"
            :structure="structures[gamma]" :domains="domains"
            @update:data="dataChanged" 
            @update:images="imagesChanged" 
            @update:signature="signatureChanged" 
            :status="status"
          />
        </div>

        <div v-if="structures[gamma] && step>=0 && (role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY')" class="footer">

          <Button :label="$t('report.edit.button_exit')" @click="exit" class="p-button-outlined p-button-danger on-the-left p-ml-3" />

          <Button v-if="step>0 && status!='PENDING_APPROVAL'" :label="$t('report.edit.button_back')" @click="back" class="p-button-secondary" />

          <div v-if="status==null || status==='DRAFT' || status==='REJECTED'" style="display: inline-block;" 
              v-tooltip.top="{ value: $t('report.edit.button_save_tooltip'), disabled: !buttons.saveDisabled }">
            <Button :label="$t('report.edit.button_save')" @click="save" class="p-button-secondary" :disabled="buttons.saveDisabled"/>
          </div>

          <Button v-if="step<=Object.keys(structures[gamma]).length-1" :label="$t('report.edit.button_next')" @click="next"/>

          <div v-if="status==null || status==='DRAFT' || status==='REJECTED'" style="display: inline-block;" 
              v-tooltip.top="{ value: $t('report.edit.button_send_tooltip'), disabled: !buttons.sendDisabled }">
            <Button v-if="step>Object.keys(structures[gamma]).length-1" :label="$t('report.edit.button_send')" @click="send" :disabled="buttons.sendDisabled" />
          </div>

          <div v-if="status==='PENDING_APPROVAL' && !role.includes('SERVICE')" style="display: inline-block;" 
              v-tooltip.top="{ value: $t('report.edit.button_reject_tooltip') }">
            <Button v-if="step>Object.keys(structures[gamma]).length-1" :label="$t('report.edit.button_reject')" @click="reject" class="p-button-danger" />
          </div>

          <div v-if="status==='PENDING_APPROVAL' && !role.includes('SERVICE')" style="display: inline-block;" 
              v-tooltip.top="{ value: $t('report.edit.button_approve_tooltip') }">
            <Button v-if="step>Object.keys(structures[gamma]).length-1" :label="$t('report.edit.button_approve')" @click="approve" class="" />
          </div>



        </div>
        <div v-if="structures[gamma] && step>=0 && role.includes('INTERNAL')" class="footer">

          <Button :label="$t('report.edit.button_exit')" @click="exit" class="p-button-outlined p-button-danger on-the-left p-ml-3" />

        </div>

      </div>

    </div>
  </div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('report.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('report.error_dialog')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />

  <IrinoxDialogDark :visible="dialog.saveSuccess" 
    mode="success" 
    :message="$t('report.edit.save_report_success')"
    :life="3000" 
    @update:visible="dialog.saveSuccess = $event" />

  <IrinoxDialogDark :visible="dialog.sendSuccess" 
    mode="success" 
    :message="$t('report.edit.send_report_success')"
    :life="3000" 
    @update:visible="dialog.sendSuccess = $event" />

  <IrinoxDialogDark :visible="dialog.approveSuccess" 
    mode="success" 
    :message="$t('report.edit.approve_report_success')"
    :life="3000" 
    @update:visible="dialog.approveSuccess = $event" />

  <IrinoxDialogDark :visible="dialog.rejectSuccess" 
    mode="success" 
    :message="$t('report.edit.reject_report_success')"
    :life="3000" 
    @update:visible="dialog.rejectSuccess = $event" />

</template>

<script>
import ReportService from '../../service/ReportService';
import ApplianceService from '../../service/ApplianceService';
import AccountService from '../../service/AccountService';
import Section from './Section';
import Overview from './Overview';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
import structure_cp from '../../../public/json/reports/structures/cp.json';
import structure_mya from '../../../public/json/reports/structures/mya.json';
import structure_mfnext from '../../../public/json/reports/structures/mfnext.json';
import structure_mpnext from '../../../public/json/reports/structures/mpnext.json';
import structure_efnext from '../../../public/json/reports/structures/efnext.json';
import structure_sf from '../../../public/json/reports/structures/sf.json';
import structure_prime from '../../../public/json/reports/structures/prime.json';
import rawDomains from '../../../public/json/reports/domains.json';
import countries from '../../../public/assets/demo/data/countries.json';

export default {
  components: {
    IrinoxDialogDark,
    // IrinoxDialogLight,
    Section,
    Overview,
  },
  data() {
    return {
      domains: {},
      countries: countries,
      structures: {},
      serialNumber: this.$route.params.serialNumber,
      reportId: this.$route.params.reportId,
      report: null,
      status: null,
      signatureData: null,
      gamme: [],
      gamma: null,
      models: [],
      modelId: null,
      serials: [],
      extras: {},
      dialog: {
        error: false,
        blockingError: false,
        saveSuccess: false,
        sendSuccess: false,
        approveSuccess: false,
        rejectSuccess: false,
      },
      step: -1,
      buttons: {
        saveDisabled: true,
        sendDisabled: true,
      },
      overwriteData: {
        REPORT: {}
      },
      company: null,
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      unit: 'userdata/unit',
      isCelsius: 'userdata/isCelsius',
      role: 'userdata/role',
      appliances: 'appliances/appliances',
      fullName: 'userdata/fullName',
    }),
  },
  created() {
    this.reportService = new ReportService();
    this.applianceService = new ApplianceService();
    this.accountService = new AccountService();
    this.fillDomains();
    this.fillDomainCountries();
    if(this.role.includes('SERVICE')) {
      this.getCompany();
    }
  },
  mounted() {
    // !!! TUTTO QUESTO SERVIVA PER MOSTRARE ELENCO MACCHINE IN TENDINA (ORA E' SOLO TESTO CON CONTROLLI SULLA SINTASSI)
    // if(this.role.includes('FACTORY') || this.role==="SUBSIDIARY" || this.role.includes("INTERNAL")) {
    //   this.reloadFactoryAppliances();
    // } else {
    //   this.reloadServiceAppliances();
    // }
    this.loadModels();
  },
  watch: {
    // storedRecipe: 'updateTemporaryRecipe',
    gamma: 'gammaChanged',
    'report.REPORT.model': 'modelChanged',
    'report.REPORT.serial_number': 'serialNumberChanged',
  },
  methods: {
    getCompany() {
        this.accountService.getCompany(this.personaltoken)
          .then(company => {
            this.company = company;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
          });
      },
    ensureReportStructureSections() {
      if(!this.report || !this.gamma || !this.structures[this.gamma]) {
        return;
      }

      for(let key of Object.keys(this.structures[this.gamma])) {
        if(!this.report[key]) {
          this.report[key] = {};
        }
      }

      if(!this.report["IMAGES"]) {
        this.report["IMAGES"] = [];
      }
      if(this.report["SIGNATURE"] === undefined) {
        this.report["SIGNATURE"] = null;
      }
      if(!this.report["RIEPILOGO"]) {
        this.report["RIEPILOGO"] = {};
      }
    },
    updateButtonsStatus() {
      this.buttons.saveDisabled = !(this.report["REPORT"] && this.report["REPORT"]["serial_number"] && this.report["REPORT"]["model"]);
      if(this.step>Object.keys(this.structures[this.gamma]).length-1) {
        this.buttons.sendDisabled = !(this.report["REPORT"] && this.isFormValid() && this.reportId && this.signatureData);
      } else {
        this.buttons.sendDisabled = true;
      }
    },
    loadReport() {
      this.reportService.getV2(this.personaltoken, this.reportId)
        .then((data) => {
          if(data.code=='200') {
            this.report = data.body.content;
            this.status = data.body.status;
            this.extras.imperial = this.report["imperial"] ?? false;
            this.gamma = this.report && this.report["REPORT"] ? this.report["REPORT"].gamma : null;
            this.fillDomainModels();
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.report = null;
            this.dialog.error = true;
            setTimeout(function () {
              this.$functions.historyBack();
            }.bind(this), 3000);
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.report = null;
          this.dialog.error = true;
          setTimeout(function () {
            this.$functions.historyBack();
          }.bind(this), 3000);
        });
    },
    loadModels() {
      this.reportService.models(this.personaltoken)
        .then((data) => {
          this.models = data;
          // this.models.push({"modelId":"EF Next S","gamma":"EF Next","accessory":"","name":"S"});
          // this.models.push({"modelId":"EF Next M","gamma":"EF Next","accessory":"","name":"M"});
          // this.models.push({"modelId":"EF Next L","gamma":"EF Next","accessory":"","name":"L"});
          // this.models.push({"modelId":"EF Next SL","gamma":"EF Next","accessory":"","name":"SL"});
          // this.models.push({"modelId":"EF Next ML","gamma":"EF Next","accessory":"","name":"ML"});
          // this.models.push({"modelId":"EF Next LL","gamma":"EF Next","accessory":"","name":"LL"});
          this.models.push({"modelId":"PRIME","gamma":"PRIME","accessory":"","name":""});
          let gs = [];
          for(let i=0; i<this.models.length; i++) {
            // if(this.models[i].gamma!="MP Next") {
              gs.push({ code: this.models[i].gamma, name: this.$functions.fixGamma(this.models[i].gamma) });
            // }
          }
          this.gamme = this.$functions.uniqByKeepFirst(gs, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));

          if(this.reportId!=null) {
            this.loadReport();
          } else {
            this.report = {}
            this.step = 0;
            if(this.$route.query.gamma) {
              this.gamma = this.$route.query.gamma;
            }
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.models = [];
          this.gamme = [];
          this.dialog.error = true;
          setTimeout(function () {
            this.$functions.historyBack();
          }.bind(this), 3000);
        });
    },
    reloadServiceAppliances() {
      this.applianceService.getAppliances(this.personaltoken)
        .then((appliances) => {
          this.$store.commit('appliances/appliances', appliances);
          this.loadModels();
        })
        .catch(error => {
          console.error("EXCEPTION " + error);
          this.$store.commit('appliances/appliances', []);
          this.dialog.error = true;
          setTimeout(function () {
            this.$functions.historyBack();
          }.bind(this), 3000);
        });
    },
    reloadFactoryAppliances() {
      this.applianceService.getFactoryAppliances(this.personaltoken)
        .then((appliances) => {
          this.$store.commit('appliances/appliances', appliances);
          this.loadModels();
        })
        .catch(error => {
          console.error("EXCEPTION " + error);
          this.$store.commit('appliances/appliances', []);
          this.dialog.error = true;
          setTimeout(function () {
            this.$functions.historyBack();
          }.bind(this), 3000);
        });
    },
    gammaChanged() {
      this.structures = {
        "CK": this.$functions.clone(structure_cp),
        "CP": this.$functions.clone(structure_cp),
        "MF Next": this.$functions.clone(structure_mfnext),
        "MYA": this.$functions.clone(structure_mya),
        "MP Next": this.$functions.clone(structure_mpnext),
        "EF Next": this.$functions.clone(structure_efnext),
        "SF": this.$functions.clone(structure_sf),
        "PRIME": this.$functions.clone(structure_prime),
      };
      this.step = -1;
      if(this.reportId==null) {
        this.status = "DRAFT";
        this.report = {};
        for(let key of Object.keys(this.structures[this.gamma])) {
          this.report[key] = {};
        }
        this.report["imperial"] = !this.isCelsius;
        this.extras.imperial = this.report["imperial"];
        this.report["REPORT"].gamma = this.gamma;
        if(this.role.includes('SERVICE')) {
          this.report["REPORT"].installer_technician = this.fullName;
          this.report["REPORT"].installer_company = this.company?.name;
        }
        this.report["IMAGES"] = [];
        this.report["SIGNATURE"] = null;
        this.report["RIEPILOGO"] = {};
        setTimeout(function () {
          this.step = 0;
          if(this.$route.query.modelId!=null && this.$route.query.gamma==this.gamma) {
            this.report["REPORT"]["model"] = +this.$route.query.modelId;
          }
        }.bind(this), 10);
      } else {
        setTimeout(function () {
          let overviewStep = Object.keys(this.structures[this.gamma]).length;
          if(this.shouldLandOnFirstIncompleteStep()) {
            let firstIncompleteStep = this.findFirstIncompleteStep();
            this.step = firstIncompleteStep>=0 ? firstIncompleteStep : overviewStep;
            if(this.step<overviewStep) {
              this.isFormValid(this.step);
            }
          } else {
            this.step = overviewStep;
          }
          this.updateButtonsStatus();
        }.bind(this), 10);
      }
      this.ensureReportStructureSections();
      this.fillDomainModels();
      this.checkAllRules();
    }, 
    shouldLandOnFirstIncompleteStep() {
      let editableRole = this.role.includes('FACTORY') || this.role.includes('SERVICE') || this.role==='SUBSIDIARY';
      return editableRole && (this.status==='DRAFT' || this.status==null);
    },
    findFirstIncompleteStep() {
      let index = 0;
      for (const [key, value] of Object.entries(this.structures[this.gamma])) {
        let sectionData = this.report[key] ?? {};
        let sectionValid = true;

        for(let vStructureField of value) {
          if(!this.isFieldValid(vStructureField, sectionData)) {
            sectionValid = false;
          }
        }

        if(!sectionValid) {
          return index;
        }
        index++;
      }
      return -1;
    },
    modelChanged() {
      this.extras.modelName = null;
      if(this.report["REPORT"]) {
        if(!this.reportId) {
          // this.report["REPORT"]["serial_number"] = null;
          if(this.$route.query.serialNumber && this.$route.query.gamma==this.gamma && (!this.$route.query.modelId || this.$route.query.modelId==this.report["REPORT"]["model"])) {
            this.report["REPORT"]["serial_number"] = this.$route.query.serialNumber;
          }
        }
        this.populateExtras();
        // this.fillDomainSerialNumbers();
      }
    },
    populateExtras() {
      for(let i=0; i<this.domains.models.length; i++) {
        if(this.domains.models[i].code==this.report["REPORT"]["model"]) {
          this.extras.modelName = this.domains.models[i].rawName;
        }
      }
    },
    fillDomains() {
      for(let d in rawDomains) {
        this.domains[d] = [];
        for(let c in rawDomains[d]) {
          let code = c.replace(/_/g, "")
          this.domains[d].push({
            code: code,
            name: this.$t('report.domains.'+d+'.'+code)
          });
        }
      }
    },
    fillDomainCountries() {
      this.domains.countries = [];
      for(let i=0; i<this.countries.data.length; i++) {
        this.domains.countries.push({ code: this.countries.data[i].name, name: this.countries.data[i].name })
      }
    },
    fillDomainSerialNumbers() {
      this.domains.serialNumbers = [];
      if(this.report["REPORT"] && this.report["REPORT"]["model"]!=null) {
        for(let a of this.appliances) {
          if(a.modelId == this.report["REPORT"]["model"]) {
            this.domains.serialNumbers.push({ code: a.serialNumber, name: a.serialNumber });
          }
        }
      }
    },
    fillDomainModels() {
      let ms = [];
      for(let i=0; i<this.models.length; i++) {
        if(this.models[i].gamma === this.gamma) {
          let rawName = this.models[i].gamma + " " + this.models[i].name + (this.models[i].accessory ? " " + this.models[i].accessory : "");
          ms.push({ 
            code: this.models[i].modelId, 
            rawName: rawName,
            name: this.$functions.fixModelName(rawName)
          });
        }
      }
      this.domains.models = this.$functions.uniqByKeepFirst(ms, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
    },
    dataChanged(updatedData) {
      // console.log("UPDATEDDATA "+JSON.stringify(updatedData));
      this.report[updatedData.section][updatedData.key] = updatedData.value;
      if(updatedData.section!="RIEPILOGO") {
        this.checkField(
          this.structures[this.gamma][updatedData.section], 
          this.report[updatedData.section],
          updatedData.key
        );
        this.triggerRules(
          this.structures[this.gamma][updatedData.section], 
          this.report[updatedData.section],
          updatedData.key
        );
      }
      this.updateButtonsStatus();
    },
    imagesChanged(images) {
      this.report["IMAGES"] = images;
      console.log("IMAGES UPDATED");
    },
    signatureChanged(signatureData) {
      this.signatureData = signatureData;
      this.updateButtonsStatus();
      console.log("SIGNATURE DATA UPDATED");
    },
    exit() {
      this.$functions.historyBack();
    },
    back() {
      this.signatureData = null;
      this.updateButtonsStatus();
      this.step--;
    },
    save() {
      if(this.reportId==null) {
        this.saveCreate();
      } else {
        this.saveUpdate(false);
      }
    },
    saveCreate() {
      this.reportService.create(this.personaltoken, this.report)
        .then((data) => {
          if(data.code=='200') {
            this.reportId = '' + data.body; //Convert from number to string
            this.dialog.saveSuccess = true;
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    saveUpdate(isComplete) {
      this.reportService.update(this.personaltoken, this.reportId, this.report, isComplete && !this.role.includes('SERVICE'))
        .then((data) => {
          if(data.code=='200') {
            if(isComplete) {
              if(this.role.includes('SERVICE')) {
                this.submit();
              } else {
                this.dialog.sendSuccess = true;
                setTimeout(function() {
                  this.$router.push({ name: 'report' });
                }.bind(this),3000);
              }
            } else {
              this.dialog.saveSuccess = true;
            }
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    next() {
      if(this.isFormValid(this.step)) {
        this.step++;
      }
    },
    send() {
      let now = this.$moment();
      this.report["RIEPILOGO"]["test_date"] = now.format("DD/MM/YYYY") + ' (DD/MM/YYYY)';
      this.report["RIEPILOGO"]["test_date_timestamp"] = now.toDate().getTime();
      this.reportService.uploadSignature(this.personaltoken, this.reportId, this.signatureData)
        .then((data) => {
          if (data.code == '200') {
            console.log(data.body);
            this.report["SIGNATURE"] = data.body;
            this.saveUpdate(true);
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    submit() {
      this.reportService.submit(this.personaltoken, this.reportId)
        .then((data) => {
          if (data.code == '200') {
            this.dialog.sendSuccess = true;
            setTimeout(function() {
              this.$router.push({ name: 'report' });
            }.bind(this),3000);
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    reject() {
      this.reportService.review(this.personaltoken, this.reportId, "REJECT")
        .then((data) => {
          if (data.code == '200') {
            this.dialog.rejectSuccess = true;
            setTimeout(function() {
              this.$router.push({ name: 'report' });
            }.bind(this),3000);
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    approve() {
      this.reportService.review(this.personaltoken, this.reportId, "APPROVE")
        .then((data) => {
          if (data.code == '200') {
            this.dialog.approveSuccess = true;
            setTimeout(function() {
              this.$router.push({ name: 'report' });
            }.bind(this),3000);
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    isFormValid(step) {
      let index = 0;
      let isValid = true;
      for (const [key, value] of Object.entries(this.structures[this.gamma])) {
        if(step==null || index===this.step) {
          let vStructure = value;

          if(!this.report[key]) {
            this.report[key] = {};
          }

          let vData = this.report[key];
          // console.log(`${JSON.stringify(vStructure)} ${JSON.stringify(vData)} ${index} ${this.step}`); 
          for(let vStructureField of vStructure) {
            // console.log("Checking "+vStructureField.key+"...");
            if(!this.isFieldValid(vStructureField, vData)) {
              isValid = false;
            }
          }
        }
        index++;
      }
      return isValid;
    },
    isFieldValid(vStructureField, vData) {
      if(vStructureField.mode==="simple") {
        // SIMPLE TYPE
        // console.log(vStructureField.key + " : " +vData[vStructureField.key])
        //Check optional/mandatory
        if(!this.isOptional(vStructureField.optional,vStructureField) && (
            typeof vData[vStructureField.key] === "undefined" ||
            vData[vStructureField.key]===null || 
            vData[vStructureField.key]===""
          )) {
          vStructureField.invalid = true;
          console.debug("Failed checks on "+vStructureField.key);
          return false;
        }
        //Other checks...
        if(vStructureField.format && !this.isFormatValid(vData[vStructureField.key], vStructureField.format)) {
          vStructureField.invalid = true;
          console.debug("Failed format checks on "+vStructureField.key);
          return false;
        }
        //Tutto a posto
        vStructureField.invalid = false;
        return true;
      } else if(vStructureField.mode==="complex") {
        // COMPLEX TYPE
        let isValid = true;
        for(let child of vStructureField.childrens) {
          if(vStructureField.type==="column") {
            if(!this.isColumnChildValid(child, vStructureField, vData)) {
              isValid = false;
            }
          } else if(vStructureField.type==="timeslots") {
            if(!this.isTimeslotsChildValid(child, vStructureField, vData)) {
              isValid = false;
            }
          } else if(vStructureField.type==="absorptions") {
            if(!this.isAbsorptionsChildValid(child, vStructureField, vData)) {
              isValid = false;
            }
          } else if(vStructureField.type==="delta") {
            if(!this.isColumnChildValid(child, vStructureField, vData)) {
              isValid = false;
            }
          }
        }
        return isValid;
      }
      return true;
    },
    isColumnChildValid(child, vStructureField, vData) {
      //Check optional/mandatory
      if((child.c_type==="text" || child.c_type==="number" || child.c_type==="select" || child.c_type==="check") && !this.isOptional(child.optional,vStructureField) && (
          typeof vData[child.c_key] === "undefined" ||
          vData[child.c_key]===null || 
          vData[child.c_key]===""
        )) {
        child.invalid = true;
        return false;
      } else if(child.c_type==="multiselect" && !this.isOptional(child.optional,vStructureField) && (
          typeof vData[child.c_key] === "undefined" ||
          vData[child.c_key].length == 0
        )) {
        child.invalid = true;
        return false;
      }
      child.invalid = false;
      return true;
    },
    isTimeslotsChildValid(child, vStructureField, vData) {
      //Check optional/mandatory
      if(!this.isOptional(child.optional,vStructureField)) {
        if(typeof vData[child.c_key] === "undefined" ||
          vData[child.c_key]===null || 
          vData[child.c_key]==="") {
            child.invalid = true;
            return false;
        } else {
          let fields = vData[child.c_key].split("|||");
          if(fields.length<2) {
            child.invalid = true;
            return false;
          } else {
            for(let field of fields) {
              if(!field) {
                child.invalid = true;
                return false;
              }
            }
          }
        }
      }
      //Check order
      let fields = vData[child.c_key].split("|||");
      if(fields[0]>fields[1]) {
        child.invalid = true;
        return false;
      }
      child.invalid = false;
      return true;
    },
    isAbsorptionsChildValid(child, vStructureField, vData) {
      //Check optional/mandatory
      if(!this.isOptional(child.optional,vStructureField)) {
        if(typeof vData[child.c_key] === "undefined" ||
          vData[child.c_key]===null || 
          vData[child.c_key]==="") {
            child.invalid = true;
            return false;
        } else {
          let fields = vData[child.c_key].split("|||");
          let count = child.c_type==="3A" ? 3 : 1;
          if(fields.length<count) {
            child.invalid = true;
            return false;
          } else {
            for(let field of fields) {
              if(!field) {
                child.invalid = true;
                return false;
              }
            }
          }
        }
      }
      child.invalid = false;
      return true;
    },
    isFormatValid(valueToCheck, regex) {
      return valueToCheck.match(regex);
    },
    isOptional(optional, vStructureField) {
      return optional || vStructureField.hidden || vStructureField.disabled;
    },
    checkField(vStructure, vData, key) {
      for(let vStructureField of vStructure) {
        if(vStructureField.mode==="simple") {
          if(vStructureField.key === key) {
            return this.isFieldValid(vStructureField, vData);
          }
        } else if(vStructureField.mode==="complex") {
          for(let child of vStructureField.childrens) {
            if(child.c_key === key) {
              if(vStructureField.type==="column") {
                return this.isColumnChildValid(child, vStructureField, vData);
              } else if(vStructureField.type==="timeslots") {
                return this.isTimeslotsChildValid(child, vStructureField, vData);
              } else if(vStructureField.type==="absorptions") {
                return this.isAbsorptionsChildValid(child, vStructureField, vData);
              } else if(vStructureField.type==="delta") {
                return this.isColumnChildValid(child, vStructureField, vData);
              }
            }
          }
        }
      }
    },
    checkAllRules() {
      for(let section in this.structures[this.gamma]) {
        this.triggerRules(
          this.structures[this.gamma][section], 
          this.report[section]
        );
      }
    },
    triggerRules(vStructure, vData, key) {
      //it works only for simple mode
      for(let vStructureField of vStructure) {
        if((!key || vStructureField.key === key) && vStructureField.rules) {
          let val = vData[vStructureField.key];
          for(let ruleKey in vStructureField.rules) {
            let ruleKeyArray = ruleKey.split('.');
            this.triggerRule(ruleKeyArray[0], ruleKeyArray[1], (val!=null && typeof val === 'object' ? val.code : val), vStructureField.rules[ruleKey]);
          }
        }
      }
    },
    triggerRule(targetSection, targetField, val, rule) {
      let vTargetStructure = this.structures[this.gamma][targetSection];
      for(let vTargetStructureField of vTargetStructure) {
        if(targetField==vTargetStructureField.key || targetField==vTargetStructureField.label) {
          if(rule.action==='hide') {
            vTargetStructureField.hidden = this.checkRule(rule, val);
          } else if(rule.action==='disable') {
            vTargetStructureField.disabled = this.checkRule(rule, val);
          }
          this.resetDisabledField(vTargetStructureField, targetSection);
          this.isFieldValid(vTargetStructureField, this.report[targetSection]);
        }
      }
    },
    checkRule(rule, val) {
      if(rule.condition.includes(typeof val === 'undefined' ? null : val)) {
        return true;
      }
      for(let condition of rule.condition) {
        if(typeof condition === 'string' && condition.startsWith("regex:")) {
          console.log("Checking regex "+condition.slice(6)+" on value "+val);
          let regex = new RegExp(condition.slice(6));
          if(regex.test(val)) {
            return true;
          }
        }
      }
      return false;
    },
    resetDisabledField(vTargetStructureField, targetSection) {
      if(!this.report[targetSection]) {
        this.report[targetSection] = {};
      }
      if(vTargetStructureField.hidden || vTargetStructureField.disabled) {
        if(vTargetStructureField.mode==='simple') {
          this.report[targetSection][vTargetStructureField.key] = null;
        } else if(vTargetStructureField.mode==='complex') {
          for(let child of vTargetStructureField.childrens) {
            this.report[targetSection][child.c_key] = null;
          }
        }
      }
    },
    getCountryNameByCode(code) {
      if(!code) return '-';
      let country = this.countries?.data?.find(c => c.code === code);
      return country ? country.name : '-';
    },
    serialNumberChanged() {
      if(this.report?.REPORT?.serial_number != null && this.isFormatValid(this.report.REPORT.serial_number, "^(1[5-9]|[2-4][0-9]|50)(0[1-9]|1[0-2])(\\d{5})M$")) {
        this.reportService.getInfoBySerialNumber(this.personaltoken, this.report.REPORT.serial_number)
          .then(data => {
            if(data.code == "200") {
              let info = data.body;
              console.log("Serial number info:", info);
              if(info?.adminCompany) {
                this.overwriteData.REPORT.nation = this.getCountryNameByCode(info.adminCompany.country);
                this.overwriteData.REPORT.city = info.adminCompany.city;
                this.overwriteData.REPORT.address = info.adminCompany.address;
                this.overwriteData.REPORT.zipcode = info.adminCompany.postalCode;
                this.overwriteData.REPORT.province = info.adminCompany.district;
                this.overwriteData.REPORT.client = info.adminCompany.companyName;
              }
              if(info?.modelId) {
                let modelExists = info.gamma == this.gamma && this.models?.some(m => m.modelId === info.modelId);
                if(modelExists) {
                  this.overwriteData.REPORT.model = info.modelId;
                } else {
                  console.warn("Model ID " + info.modelId + " not found in available models for gamma " + this.gamma + ".");
                }
              }
            }
          })
          .catch(err => {
            console.error("Error fetching serial number info:", err);
          });
      }
    }
  }
}
</script>

<style scoped>

</style>